(function() {
function shouldSkip() {
if (window.location.pathname.includes("/collections/hand-painted")) return true;
if (window.location.pathname.toLowerCase().includes("/products/hpt-")) return true;
return false;
}

function updateStatuses() {
if (shouldSkip()) return;

let textChanged = false;

// --------- Update .product-card__status ---------
/*
document.querySelectorAll('.product-card__status').forEach(el => {
  if (el.innerText.trim().toLowerCase() === "made to order") {
    // el.innerText = "In Transit";
    el.classList.remove("product-card__status--in-stock");
    el.classList.add("product-status-icon--made-to-order");
    textChanged = true;
  }
});
*/

// --------- Update .product-status-text ---------
/*
document.querySelectorAll('.product-status-text').forEach(el => {
  if (/made\s*to\s*order/i.test(el.innerText)) {
    el.innerHTML = "<strong>in transit</strong> | in transit | 6-8 week lead time";
    textChanged = true;
  }
});
*/

// --------- Update .product-status-icon class only if text changed ---------
/*
if (textChanged) {
  document.querySelectorAll('.product-status-icon--made-to-order').forEach(icon => {
    icon.classList.remove('product-status-icon--made-to-order');
    icon.classList.add('product-status-icon--in-transit');
  });
}
*/

// --------- Update cart-item__alert-text and add blue color ---------
/*
document.querySelectorAll('.cart-item__alert-text').forEach(el => {
  if (/made\s*to\s*order\s*-\s*ships\s*from\s*warehouse\s*within\s*8-12\s*weeks/i.test(el.innerText)) {
    el.innerText = "in transit - 6-8 week lead time";
    el.style.setProperty("color", "blue", "important");
    textChanged = true;
  }
});
*/

}

function waitForElements(maxRetries = 40, delay = 250) {
let attempts = 0;
const interval = setInterval(() => {
const elements = document.querySelectorAll(
'.product-card__status, .product-status-text, .product-status-icon--made-to-order, .cart-item__alert-text'
);
if (elements.length > 0 || attempts >= maxRetries) {
updateStatuses();
clearInterval(interval);
}
attempts++;
}, delay);
}

document.addEventListener("DOMContentLoaded", () => waitForElements());

// Observe DOM for dynamically added elements
const observer = new MutationObserver(() => updateStatuses());
observer.observe(document.body, { childList: true, subtree: true });
})();
